<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hkBGrz/tc-custom/9780830899395.jpg?1696024361723" alt="This image is the cover for the book The Recovery-Minded Church"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Recovery-Minded Church
      </h1>
      <p class="bookDescription body article font2">
        <p>You want to have vibrant and healthy relationships with those who struggle with addiction in your church and community. But you find yourself wondering how to meet their needs in a wise, helpful and God-honoring way. <em>The Recovery-Minded Church</em> addresses the pressing questions you are facing in ministering to those with addictions. Here you will discover a clinically informed, biblical and theological framework to love the addicts in your midst and also practical tools to help you succeed in doing so, including discussion questions after each chapter for use in small group settings. God desires to welcome his prodigal children with open arms and a spirit of celebration. We need to reflect this same kind of grace and mercy in our ministry to those with addictions, to move our churches from being recovery-resistant to recovery-minded.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan Benz, Kristina Robb-Dover
      </h2>
      
      <p class="authorDescription body article"><p>Jonathan Benz (MS, Palm Beach Atlantic University) is a clinician, public speaker, ordained minister and certified addictions professional who serves the recovery community nationally. As a leadership consultant to various agencies in the United States and United Kingdom he specializes in teaching team leadership, task efficiency, crisis management and conflict resolution to people in the midst of life transitions. He is the author of <em>Live A Legacy: Spiritual Principles for Strategic Living</em> and resides in South Florida.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a06c4ed2